import React from 'react';

export default () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 00 120 22">
      <path
        d="m 12.0001 0 l 2.6941 8.2918 h 8.7186 l -7.0535 5.1246 l 2.6942 8.2918 l -7.0534 -5.1246 l -7.0534 5.1246 l 2.6942 -8.2918 l -7.0534 -5.1246 h 8.7185 l 2.6942 -8.2918 z m 24 0 l 2.6941 8.2918 h 8.7186 l -7.0535 5.1246 l 2.6942 8.2918 l -7.0534 -5.1246 l -7.0534 5.1246 l 2.6941 -8.2918 l -7.0534 -5.1246 h 8.7185 l 2.6942 -8.2918 z m 26.6941 8.2918 l -2.6941 -8.2918 l -2.6942 8.2918 h -8.7185 l 7.0534 5.1246 l -2.6941 8.2918 l 7.0534 -5.1246 l 7.0534 5.1246 l -2.6942 -8.2918 l 7.0535 -5.1246 h -8.7186 z m 21.3059 -8.2918 l 2.6941 8.2918 h 8.7186 l -7.0535 5.1246 l 2.6942 8.2918 l -7.0534 -5.1246 l -7.0534 5.1246 l 2.6941 -8.2918 l -7.0534 -5.1246 h 8.7185 l 2.6942 -8.2918 z m 26.6939 8.2918 l -2.694 -8.2918 l -2.694 8.2918 h -8.7186 l 7.0536 5.1246 l -2.694 8.2918 l 7.053 -5.1246 l 7.053 5.1246 l -2.694 -8.2918 l 7.054 -5.1246 h -8.719 z"
        fill="currentColor"
      />
    </svg>
  );
};
